'use client';

import { SignIn } from '@clerk/clerk-react';
import { shadcn } from '@clerk/themes';
import { createRoute } from '@tanstack/react-router';

import { Navigation } from '@/components/layouts/Navigation';
import { ThemeToggle } from '@/components/ui/ThemeToggle';
import { seoHead } from '@/lib/seo/routeMeta';
import { theme } from '@/lib/ui/theme';

import { Route as rootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/sign-in',
  head: () => seoHead('/sign-in'),
  validateSearch: (
    search: Record<string, unknown>
  ): { redirect_url?: string } => ({
    redirect_url: (search.redirect_url as string) || undefined,
  }),
  component: SignInPage,
});

function SignInPage() {
  const { redirect_url } = Route.useSearch();
  const redirectUrl = redirect_url || '/dashboard';

  return (
    <div>
      <Navigation variant="solid" />
      <main className="relative flex min-h-screen items-center justify-center pt-16">
        <div
          className="absolute inset-0 -z-10 transition-opacity"
          style={{
            background: theme.gradient.hero.dark,
          }}
        />
        <div
          className="absolute inset-0 -z-10 opacity-0 transition-opacity dark:opacity-100"
          style={{
            background: theme.gradient.hero.light,
          }}
        />
        <SignIn
          routing="hash"
          forceRedirectUrl={redirectUrl}
          appearance={{
            baseTheme: shadcn,
            variables: {
              colorPrimary: '#8b5cf6',
            },
            elements: {
              formButtonPrimary: {
                color: 'white',
              },
            },
          }}
        />
      </main>
      <ThemeToggle />
    </div>
  );
}
